<template>
  <div>
    <v-app-bar flat color="black">
      <v-container max-width="1200" class="mx-auto py-1">
        <div class="title-section">
          <span class="title-text mr-2">
            <!-- Pokus o překlad přes i18n prefix 'eventTypes.', jinak raw text, jinak fallback -->
            {{ eventType ? $t(eventType) : '' }}
          </span>
        </div>
      </v-container>
    </v-app-bar>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useAppStore } from '@/stores/app/appStore';

const appStore = useAppStore();
const eventType = computed(() => appStore.eventType || appStore.currentEventType || '');
</script>

<style scoped>
.v-tab.my-tab {
  height: 30px !important;
}

.title-section {
  max-width: 1200px;
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 10px;
  text-align: center;
  padding: 3px 0;
  font-size: 0.9rem;
}

.title-text {
  font-family: 'Aileron', sans-serif;
  font-size: 1.25rem;
  font-weight: bold;
}
</style>
